import { render, staticRenderFns } from "./ProjectTemplateDetail.vue?vue&type=template&id=d844926e&scoped=true&"
import script from "./ProjectTemplateDetail.vue?vue&type=script&lang=js&"
export * from "./ProjectTemplateDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTemplateDetail.vue?vue&type=style&index=0&id=d844926e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d844926e",
  null
  
)

export default component.exports